module.exports = __webpack_public_path__ + "static/media/likeButton.c7cc734b.png";